/* 🤖 this file was generated by svg-to-ts */
export const mgcIconUpSmallRegular: {
  name: 'up-small-regular';
  data: string;
} = {
  name: 'up-small-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.82 9.2a1.183 1.183 0 0 0-.3.097c-.077.039-.819.749-1.648 1.577-1.653 1.651-1.68 1.684-1.68 2.126 0 .392.192.705.547.893.212.112.657.118.861.012.077-.04.648-.579 1.27-1.199L12 11.581l1.13 1.125c.622.62 1.193 1.159 1.27 1.199.204.106.649.1.861-.012.487-.258.683-.815.461-1.318-.122-.277-3.013-3.173-3.282-3.288a1.064 1.064 0 0 0-.62-.087"/></svg>`
};
